// extracted by mini-css-extract-plugin
export default {"table":"table__Table__5gR1e","tableWithStickyHeader":"tableWithStickyHeader__Table__5gR1e","rowFooter":"rowFooter__Table__5gR1e"};